import script from "./MedicalInformationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicalInformationForm.vue?vue&type=script&setup=true&lang=js"

import "./MedicalInformationForm.vue?vue&type=style&index=0&id=0ec3d9a7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec3d9a7"]])

export default __exports__